const LangEgiftCard = {
	"egiftCard.sendAStarbhucksEgift": ["Send a Starbucks eGift", "Gửi quà tặng điện tử"],
	"egiftCard.theFastestEasiestWay": [
		"The fastest, easiest way to gift a friend.",
		"Thật nhanh, thật dễ dàng để gửi một món quà đến bạn bè.",
	],
	"egiftCard.selectAnOccastionToGetStarted": [
		"Select an occasion to get started.",
		"Hãy chọn thẻ bên dưới.",
	],
}

export default LangEgiftCard
